import React from 'react';
import './styles.css';

const YButton = () => {
    return (
        <nav className="doctolib-widget" id="doctolib-nav" aria-label="Doctolib Schnellzugriff">
            <a href="#maincontent" className="skip-link">Zum Hauptinhalt springen</a>
            <img
                src="https://www.doctolib.de/external_button/doctolib-white-transparent.png"
                alt="Doctolib Logo"
            />
            <a
                className="doctolib-widget__link"
                href="https://www.doctolib.de/praxis/hamburg/hanse-euroderm-privatpraxis-fuer-dermatologie-aesthetische-und-lasermedizin-in-hamburg-und-neu-wulmstorf/booking?pid=practice-818046&utm_campaign=website-button&utm_source=online-booking&utm_medium=referral"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Termin Online über Doctolib buchen"
            >
                Hamburg
            </a>
            <a
                className="doctolib-widget__link"
                href="https://www.doctolib.de/praxis/hamburg/hanse-euroderm-privatpraxis-fuer-dermatologie-aesthetische-und-lasermedizin-in-hamburg-und-neu-wulmstorf/booking?pid=practice-818059&utm_campaign=website-button&utm_source=online-booking&utm_medium=referral"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Termin Online über Doctolib buchen"
            >
                Neu Wulmstorf
            </a>
            <a
                className="doctolib-widget__link"
                href="https://www.doctolib.de/praxis/hamburg/hanse-euroderm-privatpraxis-fuer-dermatologie-aesthetische-und-lasermedizin-in-hamburg-und-neu-wulmstorf/patient-request?utm_campaign=website-button&utm_source=patient-messaging&utm_medium=referral"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Nachricht an Praxis über Doctolib senden"
            >
                Nachricht
            </a>
        </nav>
    );
};

export default YButton;
